<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">update cargo entry</small>
      </legend>
      <div>
        <form @submit.prevent="cargoUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Cargo.id" />
              <input type="hidden" class="fileopening_id" :value="Cargo.fileopening_id" />
              <div class="form-group">
                <label>Cargo number</label>
                <input
                  type="text"
                  class="form-control container_no input-rounded f-s-14"
                  :value="Cargo.container_no"
                  placeholder="cargo number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Net weight</label>
                <input
                  type="text"
                  class="form-control net_weight input-rounded f-s-14"
                  :value="Cargo.net_weight"
                  placeholder="net weight of cargo"
                  required
                />
              </div>
              
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Cargo size</label>
                <select name="cargo_size" class="form-control cargo_size input-rounded f-s-14" :value="Cargo.cargo_size">
                  <option value>Select cargo size</option>
                  <option value="20">1X20</option>
                  <option value="40">1X40</option>
                  <option value="OOG">OOG</option>
                  <option value="LCL">LCL</option>
                  <option value="UNITS">UNITS</option>
                </select>
              </div>
              <div class="form-group">
                <label>Weight units</label>
                <select
                  name="weight_units"
                  class="form-control weight_units input-rounded f-s-14"
                  :value="Cargo.weight_units"
                >
                  <option value>Select weight units</option>
                  <option value="TONNES">TONNES</option>
                  <option value="KG">KG</option>
                  <option value="PACKAGES">PACKAGES</option>
                  <option value="DRUM">DRUM</option>
                </select>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingCargo btn-rounded">
            <i class="fa fa-plus"></i> update cargo
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingCargoLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
    created(){
        if (this.$store.getters.Cargo.length === 0) {
            router.push('/managecargoentries')
        }
    },
    computed: {
        ...mapGetters(["Cargo"])
    },
    methods: {
        ...mapActions(["cargoUpdate"])
    }
    
}
</script>
<style scoped>
.updatingCargoLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/cargoentries/updatecargoentry.vue